import { render, staticRenderFns } from "./frtradeprono.vue?vue&type=template&id=5ade8f03"
import script from "./frtradeprono.vue?vue&type=script&lang=js"
export * from "./frtradeprono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports